/*
 * Copyright (c) 2022. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { MenuService } from '@app/core/menu/menu.service';
import { extract } from '@app/core';
import { BankAccountsListComponent } from '@app/banks/bank-accounts/bank-accounts-list/bank-accounts-list.component';
import { BankAccountsViewComponent } from '@app/banks/bank-accounts/bank-accounts-view/bank-accounts-view.component';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'bank-accounts', component: BankAccountsListComponent, data: { title: extract('Bank accounts') } },
    {
      path: 'bank-accounts/view',
      component: BankAccountsViewComponent,
      data: { title: extract('Bank accounts view') },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BanksRoutingModule {
  constructor(menuService: MenuService) {
    menuService.addItem({
      key: 'finance.bank-accounts',
      title: 'Bank accounts',
      requiredPermission: 'bank_accounts.menu',
      path: '/bank-accounts',
    });
  }
}
